<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";
	import { Section, SectionHeader, type SectionTheme } from "#lib/web-ui/primitives/index.js";

	interface StatItem {
		value: string;
		label: string;
	}

	interface Props {
		label?: string;
		title?: string;
		subtitle?: string;
		stats?: StatItem[];
		theme?: SectionTheme;
		class?: string;
	}

	let { label, title, subtitle, stats = [], theme = "light", class: className }: Props = $props();
</script>

<Section {theme} class={className}>
	<SectionHeader {label} {title} {subtitle} />

	<div
		class={cn(
			"divide-border grid gap-8 divide-y text-center md:divide-x md:divide-y-0",
			stats.length === 3 && "md:grid-cols-3",
			stats.length === 4 && "md:grid-cols-4",
			stats.length <= 2 && "md:grid-cols-2",
			stats.length > 4 && "md:grid-cols-4"
		)}
	>
		{#each stats as stat (stat.label)}
			<div class="space-y-2 pt-8 md:pt-0">
				<div class="text-foreground text-4xl font-bold tracking-tight lg:text-5xl">
					{stat.value}
				</div>
				<p class="text-muted-foreground text-sm">
					{stat.label}
				</p>
			</div>
		{/each}
	</div>
</Section>
